<template>
	<div class="carousel" >
		<div class="carousel__items" v-dragscroll v-on:dragscrollmove="carouselDragged" ref="carouselItems">
			<div class="carousel__item"  v-for="image in images">
				<div class="carousel__image-wrap">
					<img class="carousel__image"  :src="image.src" />
					<span v-if="image.videoId" class="grunticon grunticon--play carousel__video-icon" @click="openVideo(image.videoId)"></span>
				</div>
				<div class="carousel__image-description" v-if="image.description">{{image.description}}</div>
			</div>
		</div>
		<input type="range" min="0" max="1" step="0.01" value="0" class="carousel__slider" ref="carouselSlider" @input="sliderChange">
	</div>
</template>

<script>

export default {

//	v-bind:style="{
//		transform: 'translateX(' + xPos + 'px)'
//	}"

	name: 'Carousel',
	components: {
	},
	data () {
		return {
			xPos: 0
		}
	},
	props: {
		images: Array
	},
	computed: {
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
		carouselDragged(event)
		{
			var self = this;
			var cont = self.$refs.carouselItems;
			var scrollRatio = cont.scrollLeft / (cont.scrollWidth-cont.clientWidth);
			self.$refs.carouselSlider.value = scrollRatio;
		},
		sliderChange(event)
		{
			var self = this;
			var value = event.target.value;
			var cont = self.$refs.carouselItems;
			cont.scrollLeft = value * (cont.scrollWidth-cont.clientWidth);
		},
    openVideo(videoId)
    {
     this.trackEvent([
        "carousel-watch-video-clicked",
        videoId,
        this.$root.$data.user ? this.$root.$data.user.trackName : null,
        0,
        false
      ]);
      this.$root.$data.gameVideoId = videoId;
    },
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".carousel";
	#{$c}
	{
		&__items
		{
			display: flex;
			flex-wrap: nowrap;
			align-items: stretch;
			align-content: center;
			overflow: hidden;
		}

    &__item
    {
    	width: 100%;
    	display: flex;
    	flex-direction: column;
    	flex-shrink: 0;
    }

    &__image-wrap
    {
    	display: flex;
    	flex-direction: column;
    	flex-grow: 1;
			align-items: center;
	    align-content: center;
	    justify-content: center;
    }

    &__image
    {
    	@include extend(block-img);
    	flex-shrink: 0;		// IE fix

    	&-description
    	{
    		margin-top: rem(24);
    	}
    }

    &__video-icon
    {
			position: absolute;
			width: rem(56);
			left: rem(24);
			bottom: rem(24);
			cursor: pointer;
		}

    &__slider
    {
			-webkit-appearance: none;
			display: block;
			@include extend(block-center);
			width: 100%;
			max-width: 376px;
			height: 2px;
			border-radius: 1px;
			background: palette(light-grey);
			outline: none;
			margin-top: rem(38);

			&::-webkit-slider-thumb
			{
				-webkit-appearance: none;
				appearance: none;
				width: 15px;
				height: 15px;
				border-radius: 50%;
				background: palette(blue);
				cursor: pointer;
			}

			&::-moz-range-thumb
			{
				width: 15px;
				height: 15px;
				border-radius: 50%;
				background: palette(blue);
				cursor: pointer;
			}

			&::-ms-thumb
			{
				width: 15px;
				height: 15px;
				border-radius: 50%;
				background: palette(blue);
				cursor: pointer;
			}
    }
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/Carousel.vue